import { render } from "./BaseLogo.vue?vue&type=template&id=6dc1c96f&scoped=true"
const script = {}

import "./BaseLogo.vue?vue&type=style&index=0&id=6dc1c96f&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc1c96f"]])

export default __exports__